/**
 * Holiday API Contract
 *
 * Defines the oRPC contract for Holidays - company-level holiday definitions
 * with optional location targeting and operating hours overrides.
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateHolidayInputSchema, UpdateHolidayInputSchema, HolidayResponseSchema, ListHolidaysResponseSchema, } from "@hourly/api/holiday";
import { uuidSchema } from "@hourly/api/validation-common";
// ============ Contract Definitions ============
// Create a holiday
const createHoliday = oc
    .route({
    method: "POST",
    path: "/holidays",
    summary: "Create a new holiday",
    tags: ["Holidays"],
    successStatus: 201,
})
    .input(CreateHolidayInputSchema)
    .output(HolidayResponseSchema);
// Get a holiday by ID
const getHoliday = oc
    .route({
    method: "GET",
    path: "/holidays/{id}",
    summary: "Get a holiday by ID",
    tags: ["Holidays"],
})
    .input(z.object({ id: uuidSchema }))
    .output(HolidayResponseSchema);
// List holidays for a company
const listHolidays = oc
    .route({
    method: "GET",
    path: "/holidays",
    summary: "List all holidays for a company",
    tags: ["Holidays"],
})
    .input(z.object({
    includePast: z.stringbool().optional().default(true),
}))
    .output(ListHolidaysResponseSchema);
// Update a holiday
const updateHoliday = oc
    .route({
    method: "PUT",
    path: "/holidays/{id}",
    summary: "Update a holiday",
    tags: ["Holidays"],
})
    .input(z.object({ id: uuidSchema }).merge(UpdateHolidayInputSchema))
    .output(HolidayResponseSchema);
// Delete a holiday
const deleteHoliday = oc
    .route({
    method: "DELETE",
    path: "/holidays/{id}",
    summary: "Delete a holiday",
    tags: ["Holidays"],
    successStatus: 204,
})
    .input(z.object({ id: uuidSchema }))
    .output(z.void());
// ============ Export Contract ============
export const holidayContract = {
    create: createHoliday,
    get: getHoliday,
    list: listHolidays,
    update: updateHoliday,
    delete: deleteHoliday,
};
//# sourceMappingURL=holiday.js.map